export enum FeatureState {
  Enabled = 'enabled',
  Disabled = 'disabled',
}
